<template>
  <common-wrap :preview-data="previewData" v-loading="loading">
    <div id="x-spreadsheet"></div>
  </common-wrap>
</template>

<script>
import Spreadsheet from "x-data-spreadsheet";
import commonWrap from "@/components/commonWrap";
import common from "@/mixins/common";
import { read, utils } from 'xlsx';

export default {
  name: "excel-preview",
  mixins: [common],
  components: {
    commonWrap
  },
  data() {
    return {
      loading: false,
      wb: null
    }
  },
  async mounted() {
    const res = await this.getBlobData();
    if (res) {
      this.wb = read(await res.data.arrayBuffer(), { type: 'array' });
      const s = new Spreadsheet("#x-spreadsheet", {
        mode: 'read',
        showToolbar: false,
        view: {
          height: () => {
            return window.innerHeight - 56
          },
          width: () => {
            return window.innerWidth;
          }
        }
      }).loadData(
        this.spreadsheetToSheetJs(this.wb)
      );
    }
  },
  methods: {
    spreadsheetToSheetJs(wb) {
      let out = [];
      wb.SheetNames.forEach(function (name) {
        let o = { name: name, rows: {} };
        let ws = wb.Sheets[name];
        if(!ws || !ws["!ref"]) return;
        let range = utils.decode_range(ws['!ref']);
        // sheet_to_json will lost empty row and col at begin as default
        range.s = { r: 0, c: 0 };
        let aoa = utils.sheet_to_json(ws, {
          raw: false,
          header: 1,
          range: range
        });

        aoa.forEach(function (r, i) {
          let cells = {};
          r.forEach(function (c, j) {
            cells[j] = { text: c };

            let cellRef = utils.encode_cell({ r: i, c: j });

            if ( ws[cellRef] != null && ws[cellRef].f != null) {
              cells[j].text = "=" + ws[cellRef].f;
            }
          });
          o.rows[i] = { cells: cells };
        });

        o.merges = [];
        (ws["!merges"]||[]).forEach(function (merge, i) {
          // Needed to support merged cells with empty content
          if (o.rows[merge.s.r] == null) {
            o.rows[merge.s.r] = { cells: {} };
          }
          if (o.rows[merge.s.r].cells[merge.s.c] == null) {
            o.rows[merge.s.r].cells[merge.s.c] = {};
          }

          o.rows[merge.s.r].cells[merge.s.c].merge = [
            merge.e.r - merge.s.r,
            merge.e.c - merge.s.c
          ];

          o.merges[i] = utils.encode_range(merge);
        });

        out.push(o);
      });

      return out;
    }
  }
}
</script>

<style lang="scss" scoped>
#x-spreadsheet {
  margin: 56px auto 0;
}
</style>
